<template>
  <v-container class="mx-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="px-5 pb-5" fluid v-if="Object.keys(controller).length != 0">
          <v-tabs>
            <template v-for="tab in filterTabs()">
              <v-tab
                v-if="tab.show"
                :key="tab.name"
              >
                {{ tab.name }}
              </v-tab>
              <v-tab-item
                v-if="tab.show && isDisplayInfoController"
                :key="tab.name"
                class="tab-item"
              >
                <component v-bind:is="tab.component"
                />
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GeneralInfo from './components/GeneralInfo';

export default {
  name: 'DetailController',
  props: ['id'],
  data () {
    return {
      disableRoleName: true,
      isDisplayInfoController: true,
    };
  },
  async created () {
    this.isDisplayInfoController = false;
    this.getController({
      id: this.id,
    })
      .then(() => {
        this.isDisplayInfoController = true;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке информации');
      });
  },

  computed: {
    ...mapGetters({
      roleName: 'roleName',
      controller: 'Controllers/controller',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'DetailControllerGeneralInfo',
          show: this.disableRoleName,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getController: 'Controllers/getController',
    }),
    filterTabs () {
      return this.tabs.filter(tab => {
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>
